import { ChatMessage } from '../../store/actions/chat';
import {
  ADD_CHAT,
  ADD_NEW_MESSAGE_CHAT,
  ADD_NEW_MESSAGES,
  CLEAR_CHAT,
  DELETE_CHAT_MESSAGE,
  EDIT_CHAT_MESSAGE,
  UPDATE_CHAT,
} from '../actionTypes';

interface Action {
  type: string;
  payload: { channelArn: string; messages?: ChatMessage[]; messageId?: string; text?: string };
}

const chat = (chat = {}, action: Action): { channelArn: string; messages: ChatMessage[] } | {} => {
  switch (action.type) {
    case ADD_CHAT:
      return { ...chat, [action.payload.channelArn]: action.payload.messages?.reverse() };

    case UPDATE_CHAT:
      return {
        ...chat,
        [action.payload.channelArn]: [
          ...chat[action.payload.channelArn],
          ...action.payload.messages,
        ],
      };

    case ADD_NEW_MESSAGE_CHAT:
      const messageIndex = chat[action.payload.channelArn]?.findIndex?.(
        c => c?.MessageId === action?.payload?.messages?.[0]?.MessageId,
      );
      if (messageIndex > -1) {
        const updatedMessages = chat[action.payload.channelArn]?.map((c, i) => {
          if (i === messageIndex) {
            return action?.payload?.messages?.[0];
          }
          return c;
        });

        return {
          ...chat,
          [action.payload.channelArn]: [...updatedMessages],
        };
      } else {
        return {
          ...chat,
          [action.payload.channelArn]: [
            ...chat[action.payload.channelArn],
            action?.payload?.messages?.[0],
          ],
        };
      }

    case DELETE_CHAT_MESSAGE:
      return {
        ...chat,
        [action.payload.channelArn]: chat[action.payload.channelArn]?.filter(
          (c: ChatMessage) => c?.MessageId !== action.payload.messageId,
        ),
      };

    case EDIT_CHAT_MESSAGE:
      return {
        ...chat,
        [action.payload.channelArn]: chat[action.payload.channelArn]?.map((c: ChatMessage) => {
          if (c?.MessageId === action.payload.messageId) {
            return {
              ...c,
              Content: action.payload.text,
            };
          }

          return c;
        }),
      };

    case ADD_NEW_MESSAGES:
      return {
        ...chat,
        [action.payload.channelArn]: [
          ...action.payload.messages?.reverse(),
          ...chat[action.payload.channelArn],
        ],
      };

    case CLEAR_CHAT:
      return {
        ...chat,
        [action.payload.channelArn]: [],
      };

    default:
      return chat;
  }
};

export default chat;
